/* FocusGauge — kleine SVG-gauge (BKR ratio) voor de PlanFocusWizard.
   Extracted uit RoosterPage.jsx (Prompt 05 / RoosterPage-split, feb 2026). */
import React from "react";

export function FocusGauge({ bkr }) {
  const ratio = bkr.vereist ? Math.min(100, (bkr.medewerkers_ingeroosterd / bkr.vereist) * 100) : 100;
  const color = bkr.status === "ok" ? "#059669"
              : bkr.status === "warning" ? "#d97706" : "#dc2626";
  return (
    <div className="relative w-16 h-16 shrink-0" data-testid="wizard-gauge">
      <svg viewBox="0 0 36 36" className="w-16 h-16">
        <circle cx="18" cy="18" r="15.9" fill="none" stroke="#e5e7eb" strokeWidth="3.5" />
        <circle cx="18" cy="18" r="15.9" fill="none" stroke={color} strokeWidth="3.5"
                strokeDasharray={`${ratio}, 100`} strokeLinecap="round"
                transform="rotate(-90 18 18)"
                style={{ transition: "stroke-dasharray 250ms ease-out" }} />
      </svg>
    </div>
  );
}
